'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = function (_ref, _ref2) {
  var _extends2;

  var xs = _ref.xs,
      sm = _ref.sm,
      md = _ref.md,
      lg = _ref.lg,
      xsAlign = _ref.xsAlign,
      smAlign = _ref.smAlign,
      mdAlign = _ref.mdAlign,
      lgAlign = _ref.lgAlign,
      background = _ref.background,
      borderColor = _ref.borderColor,
      borderWidth = _ref.borderWidth,
      foreground = _ref.foreground,
      radius = _ref.radius,
      styles = _ref.styles;
  var colors = _ref2.colors,
      mediaQuery = _ref2.mediaQuery,
      radiuses = _ref2.radiuses,
      rhythm = _ref2.rhythm;

  var calculateSize = function calculateSize(cols) {
    return cols ? {
      flex: '1 0 ' + 100 / 12 * cols + '%',
      maxWidth: 100 / 12 * cols + '%'
    } : {};
  };

  return {
    root: (0, _merge2.default)(_extends({
      backgroundColor: colors[background],
      color: colors[foreground],
      border: borderWidth && borderWidth + 'px solid ' + colors[borderColor],
      borderRadius: radius && rhythm(radiuses[radius]),
      textAlign: xsAlign
    }, calculateSize(xs), (_extends2 = {}, _defineProperty(_extends2, mediaQuery('sm'), _extends({
      textAlign: smAlign
    }, calculateSize(sm))), _defineProperty(_extends2, mediaQuery('md'), _extends({
      textAlign: mdAlign
    }, calculateSize(md))), _defineProperty(_extends2, mediaQuery('lg'), _extends({
      textAlign: lgAlign
    }, calculateSize(lg))), _extends2)), styles)
  };
};


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/grid-column/styles.js
// module id = 825
// module chunks = 0